import { Stack, Card, Box, useResponsiveValue } from 'braid-design-system';

const FormCard = ({ children }: { children: any }) => {
  const responsiveValue = useResponsiveValue();
  const isTabletOrAbove = responsiveValue({
    mobile: false,
    desktop: true,
    tablet: true,
  });

  if (isTabletOrAbove) {
    return (
      <Card rounded>
        <Box padding={{ tablet: 'small', desktop: 'small' }}>
          <Stack space="large">{children}</Stack>
        </Box>
      </Card>
    );
  }

  return (
    <Box paddingX="medium" paddingY="xxsmall">
      <Stack space="medium">{children}</Stack>
    </Box>
  );
};

export default FormCard;
